export default __webpack_public_path__ + "static/media/camera-icon.3b2c75f7.svg";